import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { appCommonConstants } from '../../../../app.constants';

@Component({
  selector: 'app-info',
  styles: ['li{line-height: 1.25rem;}'],
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule
  ],
  template: `
    <div *ngIf="isLoading" class="loading-spinner"></div>
    <div *ngIf="!isLoading">
      <h6 class="text-uppercase">{{'WORD.LIBRERIE INSTALLATE'|translate}}</h6>
      <ul @fadeInOut class="m-0 p-0" style="list-style: none;">
          <li *ngFor="let component of components">{{ component }}</li>
      </ul>
    </div>
  `,
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate('.25s ease-out', style({ opacity: '1' })),
        transition(':leave', [
          style({ opacity: '1' }),
          animate('.25s ease-out', style({ opacity: '0' })),
        ]),
      ])
    ])
  ]
})

export class AppInfoComponent implements OnInit {
  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.isLoading = true;
    this.http.get(appCommonConstants.url.appInfo).subscribe((response: any) => {
      this.components = response;
      this.isLoading = false;
    });
  }

  public components: string[] = [];
  public isLoading = true;
}
